import { render, staticRenderFns } from "./ContatoWebCheckin.vue?vue&type=template&id=05b2556f&scoped=true&"
import script from "./ContatoWebCheckin.vue?vue&type=script&lang=js&"
export * from "./ContatoWebCheckin.vue?vue&type=script&lang=js&"
import style0 from "./ContatoWebCheckin.vue?vue&type=style&index=0&id=05b2556f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b2556f",
  null
  
)

export default component.exports